module.exports = __webpack_public_path__ + "static/media/instagram.1d968e51.png";